function mistakeCorrection(callback) {
	require.ensure(['./script.js', './mistake-correction.css'], function (require) {
		require('./script.js');
		require('./mistake-correction.css');
	});
}

function checkMCMode() {
	if (typeof BX !== 'undefined' && BX.message('USER_ID')) {
		if (window.location.search.search('mistake_correction_mode=Y') !== -1) {
			toggleMCMode($($('#mc-panel-toggle').parents('a')[0]), false);
		}
	}
}

function toggleMCMode(item, clicked) {
	item.toggleClass('mc-active');
	item.find('.bx-panel-button-icon').attr('style', function (i, s) {
		// хак чтобы перезаписать битровское инлайновые стили с импортантами
		var toggleStyle = 'background-color: #66d533 !important;';
		if (s.search(toggleStyle) == -1) {
			return s + toggleStyle;
		} else {
			return s.replace(toggleStyle, '');
		}
	});
	item.parent().find('.bx-panel-button-text').hide();
	var mcModeState = $('#mc-mode-state').text();
	$('#mc-mode-state').text(mcModeState == 'выключен' ? 'включен' : 'выключен');

	if (clicked) {
		// если функция вызвана кликом по иконке – тогглим get-параметр
		if (window.location.search.search('mistake_correction_mode=Y') !== -1) {
			// есть get-параметр, выпиливаем его
			if (window.location.search.indexOf('mistake_correction_mode=Y') == 1) {
				// стоит первым в списке get-параметров
				window.location.search = window.location.search.replace(/mistake_correction_mode\=Y\&?/, '');
			} else {
				// в середине или в конце списка гет-параметров
				window.location.search = window.location.search.replace(/\&mistake_correction_mode\=Y/, '');
			}
		} else {
			// get-параметра нет, добавляем его
			if (window.location.search.length) {
				window.location.search += '&mistake_correction_mode=Y';
			} else {
				window.location.search = 'mistake_correction_mode=Y';
			}
		}
	}
	mistakeCorrection();
}

$(window).on('load', function () {
	checkMCMode();
	// проверяем, включен ли режим правок
});

global.mistakeCorrection = mistakeCorrection;
global.toggleMCMode = toggleMCMode;



/** WEBPACK FOOTER **
 ** ./frontend/components/mistake-correction/mistake-correction.js
 **/